<template>
	<div class="">
		<FormGroupBox :icon="tripIcon" :title="`Servicio #${serviceNumber}`">
			<template
				#append-title
			>
				<span v-if="id > 0 && revisedByUser != null"
					v-b-tooltip.hover
					:title="'Servicio validado por ' + revisedByUser"
					class="small text-success ml-2"
					pill variant="info">
					<md-icon icon="verified" />
				</span>

				<div v-if="id > 0 && status !== 'canceled'">
					<b-form-checkbox
						v-if="revisedByUser == null"
						size="sm"
						class="ml-3 mt-2"
						variant="secondary"
						v-b-tooltip.hover
						title="Si marca como validado, esta opción no se podrá revertir"
						@change="revised"
						switch>
						Marcar como validado
					</b-form-checkbox>
				</div>

			</template>

			<b-form-row v-if="id > 0" class="justify-content-end mt-3 align-items-center" style="max-width: 95%;">
				<small
					class="m-0"
					v-if="$hasPermission('reservation.createdInfo')"
					><strong>Servicio creado por: </strong
					><span> {{ creationUser.firstName }} |</span>
					{{ creationDatetimeStr }}</small
				>
				<small class="m-0" v-else
					><strong>Servicio creado: </strong
					>{{ creationDatetimeStr }}</small
				>
				<b-badge
					class="ml-2"
					v-if="domainPointOfsale !== false"
					variant="primary"
				>
					{{ domainPointOfsale }}</b-badge
				>
				<span v-if="id > 0">
					<b-button
						v-if="(ratePlanType != 'sc' && ratePlanType != '') || sourceLabel=='API' && $hasPermission('reservation.apiData')"
						@click="consultApiData"
						size="sm"
						variant="warning"
						class="ml-2"
					>
						<md-icon icon="link" /> Api {{ ratePlanType }}
					</b-button>
				</span>
			</b-form-row>
			<b-form-row v-if="id > 0 && cancelDatetime" class="justify-content-end align-items-center">
				<small><b>Fecha cancelación:</b> <date-label :date="cancelDatetime"/></small>
			</b-form-row>
			<hr />
			<b-form-row
				class="justify-content-end"
				v-if="$hasPermission('reservation.service.header')"
			>
				<b-form-group class="col-md-3" label="Contacto">
					<b-form-select
						:disabled="unableEdit"
						size="sm"
						v-model="contactStatus"
						:options="contactStatusOpts"
					/>
				</b-form-group>

				<b-form-group
					class="col-md-3 text-center"
					label="Web Check-in"
					v-if="$hasPermission('reservation.webcheckin.edit')"
				>
					<b-dropdown
						:text="statusWebCheckinLabel"
						size="sm"
						:variant="statusWebCheckinVariant"
					>
						<b-dropdown-item
							v-for="(item, key) in statusWebCheckinOpts"
							:key="key"
							href="#"
							@click="$emit('changeWebCheckinStatus', item.value)"
						>
							{{ item.text }}
						</b-dropdown-item>
					</b-dropdown>
				</b-form-group>

				<b-form-group class="col-md-3 text-center" label="Status Pago">
					<md-icon
						class="text-success"
						icon="check"
						v-if="paymentStatus == 'paid'"
					/>
					<md-icon icon="check" v-if="paymentStatus == 'pending'" />
					<b-spinner
						variant="success"
						small
						type="grow"
						v-if="paymentStatus == 'waiting'"
					/>
					<b>{{ itemPaymentStatus.text }}</b>
					<md-icon v-if="ratePlanType != 'sc' && ratePlanType != '' && (status == 'active' || status == 'pending') && (paymentStatus != 'paid')"
						class="text-warning ml-1 shake"
						v-b-tooltip.hover
						v-b-tooltip.placement.right
						title="Si el servicio no se paga dentro de las primeras 24hrs en las que se creó un link de pago, será cancelado automaticamente."
						icon="warning"/>
				</b-form-group>

				<b-form-group class="col-md-3 text-center" label="Estado">
					<b-form-select
						v-if="isNew"
						size="sm"
						v-model="status"
						:options="transportStatusOpts"
					/>
					<h4 v-else class="mb-0">
						<b-badge :variant="statusVariant" size="md" class="p-0">
							{{ statusLabel }}
						</b-badge>
						<BtnEvidence
							:status="status"
							:id="id"
							:label="statusLabel"
							:qtyFiles="evidenceFilesTotal"
						/>
						<b-button
							v-if="canResetStatus"
							title="Reestablecer estado"
							@click="
								$emit('changeStatus', 'active', 'notSelected')
							"
							size="sm"
							variant="info"
							><md-icon icon="settings_backup_restore"
						/></b-button>
					</h4>
					<small v-if="reasonStateLabel != ''"
						>({{ reasonStateLabel }})</small
					>
				</b-form-group>
			</b-form-row>
			<hr />
			<b-row class="justify-content-between" no-gutters>
				<b-col>
					<FormLocation
						label="Origen"
						:formTypeWork=formTypeWork
						:place-id.sync="pickupPlaceId"
						:place.sync="pickup"
						:index="index"
						:unable-edit="unableEdit"
					/>
				</b-col>
				<b-col md="auto" v-if="!unableEdit">
					<b-form-group class="text-center ml-1 mr-1" label=".">
						<b-button @click="swapPlaces" size="sm" variant="info"
							><md-icon icon="swap_horiz"
						/></b-button>
					</b-form-group>
				</b-col>
				<b-col>
					<FormLocation
						label="Destino"
						:formTypeWork=formTypeWork
						:place-id.sync="dropoffPlaceId"
						:place.sync="dropoff"
						:index="index"
						:unable-edit="unableEdit"
					/>
				</b-col>
				<b-col md="auto">
					<b-form-group class="text-center ml-1 mr-1" label=".">
						<b-button
							:href="routeUrl"
							target="_blank"
							size="sm"
							variant="info"
							><md-icon icon="directions"
						/></b-button>
					</b-form-group>
				</b-col>
			</b-row>
			<FormFligh
				:index="index"
				v-if="requireFlightDatas"
				:unable-edit="unableEdit"
			/>
			<FormPickup
				:index="index"
				:require-flight-datas="requireFlightDatas"
				:unable-edit="unableEdit"
			/>
			<hr />
			<div>
				<b-form-row class="justify-content-end" v-if="!$root.isEmpty(salesChannelPromoData)">
					<div>
						<b-button variant="outline-primary" @click="openPromoData" class="text-uppercase p-1" v-b-tooltip.hover="'[Canal de venta] Ver Promociones / Modicadores de tarifa'">
							<div v-if="!$root.isEmpty(promoCode)">
								<md-icon icon="sell" /> <b-badge pill variant="primary">{{ promoCode }}</b-badge>
							</div>
							<div  v-else>
								<md-icon icon="price_change"/>
								<md-icon icon="trending_up"/>
							</div>
						</b-button>
					</div>
				</b-form-row>
				<b-form-row>


					<b-form-group class="col-md-4" label="Canal de venta">
						<Multiselect
							:options="salesChannelsOpts"
							v-model="salesChannel"
							:disabled="unableEdit"
							label="text"
							track-by="value"
						/>
						<!-- <b-form-select
							:disabled="unableEdit"
							size="sm"
							v-model="salesChannelId"
							:options="salesChannelsOpts"
							required
						/> -->
					</b-form-group>
					<b-form-group class="col-md-5" label ="Tipo de servicio">
						<template slot="label" slot-scope="">
								<span>Tipo de servicio </span>
								<b-overlay no-wrap :show="loadingServicesSalesChannel" ></b-overlay>
						</template>
						<b-form-input
							size="sm"
							readonly
							v-if="serviceTypeName && ratePlanType != 'sc'"
							:value="serviceTypeName + ' - ' + ratePlanType"
						></b-form-input>
						<multiselect
						:value="stItemSelected"
						:options="serviceTypesGrouped"
						group-values="items"
						group-label="label"
						:group-select="false"
						placeholder="Type to search"
						label="text"
						track-by="value"
						:disabled="unableEdit"
						@select="(v)=>serviceTypeId = v.id"
						>
							<span slot="noResult">Oops! No se encontraron resultados.</span>
						</multiselect>
					</b-form-group>

					<b-form-group
						class="col-md-3"
						label="Referencia canal"
						v-if="
							$hasPermission('reservation.service.channelreference')
						"
					>
						<b-form-input
							style="padding: 1.15rem 0.5rem;"
							:disabled="unableEdit"
							type="text"
							size="sm"
							v-model="salesChannelReference"
						/>
					</b-form-group>
					<b-form-group class="col-md-12" label="Notas del Cliente">
						<b-textarea
							:disabled="unableEdit"
							size="sm"
							v-model="clientNote"
						/>
					</b-form-group>
				</b-form-row>
			</div>
			<!-- inf. formulario de proveedor -->


			<FormSupplier :unable-edit="unableEdit" :index="index" :serviceTypesOpts="serviceTypesOpts"/>



			<div class="row">
				<div class="col-12">
					<FormTags :index="index" :unableEdit="unableEdit"></FormTags>
				</div>

			</div>
			<hr />
			<div class="row justify-content-center box-btns">
				<div class="col col-sm-2 p-1">
					<b-button
						v-if="enableCopy"
						variant="dark"
						class="w-100 h-100"
						@click="emitClone"
						><md-icon icon="library_add" /> Copiar</b-button
					>
				</div>

				<template v-if="!unableEdit">
					<template v-if="id > 0 && status != 'pending'">
						<div class="col col-sm-2 p-1">
							<b-button
								size="sm"
								class="w-100 h-100"
								v-if="$hasPermission(
										'reservation.status.preCancel'
									)"
								@click="
									$emit(
										'changeStatus',
										'partialCancellation',
										reasonState
									)
								"
								:variant="
									$root.auxVars.transportServiceStatusClasses
										.partialCancellation
								"
								><md-icon icon="delete" /> Pre
								Cancelado</b-button
							>
						</div>
						<div class="col col-sm-2 p-1">
							<b-button
								size="sm"
								class="w-100 h-100"
								v-if="$hasPermission('reservation.status.noShow')"
								@click="
									$emit('changeStatus', 'noShow', reasonState)
								"
								:variant="
									$root.auxVars.transportServiceStatusClasses
										.noShow
								"
								><md-icon icon="perm_identityhelp_outline" /> No
								show</b-button
							>
						</div>
						<div class="col col-sm-2 p-1">
							<b-button
								size="sm"
								class="w-100 h-100"
								v-if="
								$hasPermission('reservation.status.notAttended')"
								@click="
									$emit(
										'changeStatus',
										'noProvided',
										reasonState
									)
								"
								:variant="
									$root.auxVars.transportServiceStatusClasses
										.noProvided
								"
								><md-icon icon="directions_carhelp_outline" />
								No atendido</b-button
							>
						</div>
						<div class="col col-sm-2 p-1">
							<b-button
								size="sm"
								class="w-100 h-100"
								v-if="$hasPermission('reservation.status.cancel')"
								@click="
									$emit(
										'changeStatus',
										'canceled',
										reasonState
									)
								"
								:variant="
									$root.auxVars.transportServiceStatusClasses
										.canceled
								"
								><md-icon icon="delete" /> Cancelar
								Servicio</b-button
							>
						</div>
						<div class="col col-sm-2 p-1">
							<b-button
								size="sm"
								class="w-100 h-100"
								v-if="$hasPermission('reservation.status.done')"
								@click="
									$emit('changeStatus', 'done', reasonState)
								"
								:variant="
									$root.auxVars.transportServiceStatusClasses
										.done
								"
								><md-icon icon="done" /> Realizado</b-button
							>
						</div>
					</template>

				</template>
				<b-button
					v-if="
						status == 'pending' &&
							id > 0 &&
							$hasPermission('reservation.status.confirm')
					"
					size="sm"
					class="mr-1"
					@click="$emit('changeStatus', 'active', reasonState)"
					variant="success"
					><md-icon icon="done" /> Confirmar</b-button
				>
				<b-button v-if="id <= 0" variant="danger" @click="emitDelete"
					><md-icon icon="delete" /> Eliminar</b-button
				>
			</div>

			<b-form-row v-if="fromQuote">
				<b-col class="col-3 offset-9 mt-3">
					<b-card-group deck class="mb-3">
						<b-card
							no-body
							border-variant="light"
							header="Booking total"
							class="text-right"
						>
							<b-card-text class="p-2"
								><h5 class="text-success text-right">
									${{ quote.bookingPriceTotal }}
									<span class="text-uppercase">{{
										quote.bookingCurrency
									}}</span>
								</h5></b-card-text
							>
						</b-card>
					</b-card-group>
				</b-col>
			</b-form-row>
			<b-modal
				hide-footer
				size="lg"
				ref="api-data"
				:title="
					`Datos de booking vía Api ${ratePlanType} | Servicio #${serviceNumber}`
				"
			>
				<ApiData :index="index" :transportServiceId="id" />
			</b-modal>

			<b-modal
				hide-footer
				size="lg"
				ref="promo-data"
				:title="
					`Promociones | Servicio #${serviceNumber}`
				"
			>
				<div>
					<section style="">
						<div v-for="(item, key) in salesChannelPromoData" :key="key" class="container mb-5">
							<h4>Promo {{ key+1 }}:</h4>
							<div class="container" style="max-height: 35vh;background-color: #fff; border-left: 6px solid #04AA6D; overflow-y: scroll;box-shadow: 0 2px 4px 0 rgba(0,0,0,0.16),0 2px 10px 0 rgba(0,0,0,0.12)">
								<pre>{{ item }}</pre>
							</div>
						</div>
					</section>
				</div>
			</b-modal>
		</FormGroupBox>
	</div>
</template>

<script>
import BtnEvidence from "../helpers/_btnEvidence.vue";
import FormGroupBox from "@/components/helpers/FormGroupBox";
import ApiData from "../helpers/_apiData.vue";
import Multiselect from "vue-multiselect";
import { mapFields } from "../helpers/helpers";
//Sub formularios de este formulario
import FormSupplier from "./FormSupplier";
import FormPickup from "./FormPickup";
import FormFligh from "./FormFlights";
import FormLocation from "./FormLocation.vue";
import FormTags from "./FormTags";
import MdIcon from "../../../../helpers/MdIcon.vue";
import moment from "moment";
import api from '../../../../../api.js'
import DateLabel from '../../../../helpers/DateLabel.vue';
import { mapState } from "vuex";
export default {
	props: {
		index: Number,
		model: {
			type: Object,
			required: true
		},
		enableCopy: {
			type: Boolean,
			required: true
		},
		formTypeWork:{
			type: String,
			required: false
		},
	},
	components: {
		Multiselect,
		FormSupplier,
		FormFligh,
		FormPickup,
		BtnEvidence,
		FormLocation,
		FormGroupBox,
		MdIcon,
		ApiData,
		DateLabel,
		FormTags
	},
	data() {
		return {
			salesChannel: null,
			serviceTypesSalesChannel:[],
			loadingServicesSalesChannel:false
		}
	},
	watch: {
		serviceTypeId(v) {
			if(this.id === -1) {
				this.supplierServiceTypeId = v
			}
		},
		salesChannelId(v) {
			this.loadSalesChannelD(v)
		},
		salesChannel(v) {
			if(!v) {
				return this.salesChannelId = null
			} else {
				this.salesChannelId = v.id
				this.searchServicesSalesChannel(v.id)
			}
		}
	},
	beforeCreate() {
		this.$options.computed = {
			...mapState({"reservationCreationDatetime": state=> state.reservation.viewModel.creationDatetime??null}),
			//El viewModel principal esta en el modulo reservation de vuex store
			...mapFields({
				fields: [
					"id",
					"contactStatus",
					"status",
					"voucherUrl",
					"pickupPlaceId",
					"pickup",
					"dropoffPlaceId",
					"dropoff",
					"pointOfSale",
					"serviceTypeId",
					"supplierServiceTypeId",
					"serviceTypeName",
					"serviceNumber",
					"salesChannelId",
					"salesChannelReference",
					"fromQuote",
					"quote",
					"paymentStatus",
					"clientNote",
					"checkinStatus",
					"creationUser",
					"creationDatetime",
					"cancelDatetime",
					"reasonState",
					"ratePlanType",
					"revisedByUser",
					"revisedAt",
					"evidenceFilesTotal",
					"salesChannelPromoData",
					"promoCode",
					"sourceLabel"
				],
				fieldArray: "transportServices",
				index: this.$options.propsData.index,
				base: "viewModel",
				mutation: "SET_UPDATE_MODEL_ARRAY",
				module: "reservation"
			}),
			serviceCategory() {
				return this.serviceTypesOpts.find(({value}) => value === this.serviceTypeId)?.serviceTypeCategory?.name
			},
			creationDatetimeStr() {
				return moment(this.creationDatetime).format(
					"DD/MMMM/YYYY HH:mm:ss"
				);
			},
			canResetStatus() {
				return (
					this.$hasPermission("reservation.status.reset") &&
					this.status !== "active" &&
					this.status !== "pending"
				);
			},
			statusLabel() {
				return this.$root.auxVars.transportServiceStatusOpts.find(
					status => status.value === this.status
				).text;
			},
			statusVariant() {
				return this.$root.auxVars.transportServiceStatusOpts.find(
					status => status.value === this.status
				).class;
			},
			statusWebCheckinVariant() {
				return this.$root.auxVars.webCheckingStatus.find(
					status => status.value === this.checkinStatus
				)?.class;
			},
			statusWebCheckinLabel() {
				return this.$root.auxVars.webCheckingStatus.find(
					status => status.value === this.checkinStatus
				)?.text;
			},
			statusWebCheckinOpts() {
				return this.$root.auxVars.webCheckingStatus;
			},
			routeUrl() {
				let originQuery;
				if (this.pickup.latitude && this.pickup.longitude) {
					originQuery = `${this.pickup.latitude},${this.pickup.longitude}`;
				} else {
					originQuery = encodeURIComponent(this.pickup.name);
				}
				let destinationQuery;
				if (this.dropoff.latitude && this.dropoff.longitude) {
					destinationQuery = `${this.dropoff.latitude},${this.dropoff.longitude}`;
				} else {
					destinationQuery = encodeURIComponent(this.dropoff.name);
				}
				return `https://www.google.com/maps/dir/?api=1&origin=${originQuery}&destination=${destinationQuery}&travelmode=driving`;
			},
			requireFlightDatas() {
				return this.pickup.isAirport || this.dropoff.isAirport;
			},
			unableEdit() {
				if (!this.$hasPermission("reservation.booking.edit"))
					return true;
				return this.status !== "active" && this.status !== "pending";
			},
			tripIcon() {
				if (this.pickup.isAirport) return "flight_land";
				//A2H
				else if (this.dropoff.isAirport) return "flight_takeoff";
				//H2A
				else return "place"; //P2P
			},

			isNew() {
				//cual es el origen de this.id?
				return this.id == -1;
			},
			contactStatusOpts() {
				return this.$root.auxVars.transportServiceContactStatusOpts;
			},

			transportStatusOpts() {
				if (this.isNew) {
					return [
						{ value: "active", text: "Activo" },
						{ value: "pending", text: "Pendiente" }
					];
				} else {
					return this.$root.auxVars.transportServiceStatusOpts;
				}
			},
			salesChannelsOpts() {
				if (
					this.salesChannelId != -1 &&
					!!this.supplier &&
					!this.$root.auxVars.salesChannelsOpts.find(
						st => st.value == this.salesChannelId
					)
				) {
					return [
						{
							value: this.supplier.id,
							text: this.supplier.name
						},
						...this.$root.auxVars.salesChannelsOpts
					];
				}
				return this.$root.auxVars.salesChannelsOpts;
			},
			serviceTypesOpts() {
				return this.$root.auxVars.serviceTypesOpts;
			},

			domainPointOfsale() {
				return this.pointOfSale?.domain ?? false;
			},
			itemPaymentStatus() {
				return this.$root.getItemFromAuxVarOpts(
					"transportServicePaymentStatusOpts",
					this.paymentStatus
				);
			},
			reasonStateLabel() {
				if (this.reasonState) {
					return this.reasonState.label;
				}

				return "";
			},
			serviceTypesSalesChannelFormatted(){
				let items = [];
				this.serviceTypesSalesChannel.forEach(element => {
					let item = this.serviceTypesOpts.find(({value}) => value === element.id)
					items.push(item);
				});
				return items;
			},
			serviceTypesGrouped(){
				let grouped = [];
				let item = {
					label: "Servicios ["+(this.salesChannel?.name??"")+"]",
					items: this.serviceTypesSalesChannelFormatted
				};
				grouped.push(item);
				let item2 = {
					label: "Todos los servicios",
					items: this.serviceTypesOpts
				};
				grouped.push(item2)
				return grouped


			},
			stItemSelected(){
				return this.serviceTypesOpts.find(({value}) => value === this.serviceTypeId)
			}
		};
	},
	mounted(){
		this.loadSalesChannelD(this.salesChannelId)
	},
	methods: {
		loadSalesChannelD(value) {
			if(value !== this.salesChannel?.id) {
				this.salesChannel = this.salesChannelsOpts.find(item => item.value === value)
			}
		},
		swapPlaces() {
			let aux = this.pickup;
			this.pickup = JSON.parse(JSON.stringify(this.dropoff));
			this.dropoff = JSON.parse(JSON.stringify(aux));
			aux = this.pickupPlaceId;
			this.pickupPlaceId = this.dropoffPlaceId;
			this.dropoffPlaceId = aux;
		},
		emitDelete() {
			this.$emit("delete");
		},
		emitClone() {
			this.$emit("clone");
		},
		consultApiData() {
			this.$refs["api-data"].show();
		},
		revised(value) {
			const currentUser = this.$root.store.state.currentUser;
			if(value) {
				api(this).post(`transport-services/revised/${this.id}`).then(() => {
					this.revisedByUser = currentUser.firstName
					console.log('b', this.revisedByUser)

					this.$root.showAlert('Servicio marcado como validado', {variant:'success'})
					this.$root.$emit(
						"bv::refresh::table",
						"reservations-index-list"
					);
					// this.$emit('refreshModel')
					close()
				}).catch( err => {
					this.$root.handleRequestError(err)
				});
			}
		},
		searchServicesSalesChannel(salesChannelId){
			if(!(salesChannelId>0)) return
			this.loadingServicesSalesChannel = true;
			this.serviceTypesSalesChannel = [];
			let filters = {
				pickupPlace :{ref:this.pickup.ref},
				dropoffPlace:{ref:this.dropoff.ref},
				reservationCreationDatetime :this.reservationCreationDatetime
			}
			api(this).get(`service-types/sales-channel/${salesChannelId}`,{params: {filters:filters}}).then((res) => {
				this.serviceTypesSalesChannel = res.data;
			}).catch( err => {
				this.$root.handleRequestError(err)
			}).finally(()=>{
				this.loadingServicesSalesChannel = false;
			})
		},
		openPromoData(){
			this.$refs["promo-data"].show();
		}
	}
};
</script>

<style scoped>
/* Animation property */
.shake {
    animation: wiggle 2s linear infinite;
}
/* Keyframes */
@keyframes wiggle {
    0%,
    7% {
        transform: rotateZ(0);
    }
    15% {
        transform: rotateZ(-15deg);
    }
    20% {
        transform: rotateZ(10deg);
    }
    25% {
        transform: rotateZ(-10deg);
    }
    30% {
        transform: rotateZ(6deg);
    }
    35% {
        transform: rotateZ(-4deg);
    }
    40%,
    100% {
        transform: rotateZ(0);
    }
}
</style>

<style scoped>
.category {
	position: relative;
	top: -3px;
}
</style>

